import React from 'react';
import { Icon } from '@iconify/react';
import './Contact.css';
import Header from './Header';
import Footer from './Footer';

const Contact = () => {
  return (
    <div className="contact-app">
      {/* Header Component */}
      <Header activePage="contact" />

      {/* Main Contact Content */}
      <main className="contact-page">
        <div className="contact-container">
          <div className="contact-header">
            <h1 className="contact-main-title">Let's Build Experiences Together.</h1>
            <p className="contact-subtitle">Contact me through any of the channels below.</p>
          </div>
          
          <div className="contact-cards">
            <a 
              href="https://www.google.com/maps/place/Queens,+NY" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="contact-card"
            >
              <div className="contact-card-icon">
                <Icon icon="material-symbols:location-on" width="48" height="48" />
              </div>
              <div className="contact-card-content">
                <h3 className="contact-card-title">Location</h3>
                <p className="contact-card-text">Queens, New York</p>
              </div>
            </a>
            
            <a 
              href="tel:+19296661298" 
              className="contact-card"
            >
              <div className="contact-card-icon">
                <Icon icon="material-symbols:call" width="48" height="48" />
              </div>
              <div className="contact-card-content">
                <h3 className="contact-card-title">Phone</h3>
                <p className="contact-card-text">+1 (929)-666-1298</p>
              </div>
            </a>
            
            <a 
              href="mailto:subeksha.thapa@outlook.com?subject=Hello%20Subeksha!%20Let's%20discuss%20a%20project" 
              className="contact-card"
            >
              <div className="contact-card-icon">
                <Icon icon="material-symbols:mail" width="48" height="48" />
              </div>
              <div className="contact-card-content">
                <h3 className="contact-card-title">Email</h3>
                <p className="contact-card-text">subeksha.thapa@outlook.com</p>
              </div>
            </a>
            
            <a 
              href="https://www.linkedin.com/in/subeksha-thapa/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="contact-card"
            >
              <div className="contact-card-icon">
                <Icon icon="skill-icons:linkedin" width="48" height="48" />
              </div>
              <div className="contact-card-content">
                <h3 className="contact-card-title">LinkedIn</h3>
                <p className="contact-card-text">Connect with me</p>
              </div>
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Contact;
